"use client";

import React, { useState } from "react";
import { Box, Button, Dialog, Fade, styled } from "@mui/material";
import isValidUrl from "@/lib/helpers/isValidUrl";
import ReviewWidgetFrame from "@/components/shared/ReviewWidgetFrame";

const ReviewsButton = styled(Button)(({ theme }) => ({
  width: "fit-content",
  height: "32px",
  borderRadius: "4px",
  fontFamily: "Inter, sans-serif",
  fontSize: "12px",
  padding: "0 14px 0 10px",
  border: "none",

  "&:hover": {
    border: "none",
  },

  "& img": {
    width: "70px",
    marginRight: "6px",

    // Float - Small: 20% smaller Google logo (height and width scale together) on
    // the compact mobile card.
    [theme.breakpoints.down("sm")]: {
      width: "56px",
    },
  },
}));

const WidgetContainer = styled(Box)({
  padding: "32px",
});

const WIDGET_TYPES = {
  SOURCR_FOOTER: "SOURCR_FOOTER",
  SOURCR_OTHER: "SOURCR_OTHER",
  GOOGLE_REVIEWS: "GOOGLE_REVIEWS",
};

const imagePath = (type) => {
  switch (type) {
    case WIDGET_TYPES.SOURCR_FOOTER:
      return "/img/floats/sourcr-logo.svg";
    case WIDGET_TYPES.SOURCR_OTHER:
      return "/img/floats/sourcr-logo.svg";
    default:
      return "/img/floats/google-logo.svg";
  }
};

const deriveWidgetType = (widget) => {
  if (widget.includes("sourcr.com")) {
    return widget.includes("type: 'footer'") || widget.includes("type: 'aside'")
      ? WIDGET_TYPES.SOURCR_FOOTER
      : WIDGET_TYPES.SOURCR_OTHER;
  }
  return WIDGET_TYPES.GOOGLE_REVIEWS;
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

export default function Reviews({ reviewsWidget }) {
  const [open, setOpen] = useState(false);
  const type = deriveWidgetType(reviewsWidget);
  const isUrl = isValidUrl(reviewsWidget);

  const handleOpenReviews = () => {
    if (isUrl) {
      window.open(reviewsWidget, "_blank");
      return;
    }
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      {type === WIDGET_TYPES.SOURCR_FOOTER && (
        <ReviewWidgetFrame html={reviewsWidget} title="Reviews" minHeight={64} />
      )}
      {type !== WIDGET_TYPES.SOURCR_FOOTER && (
        <>
          <ReviewsButton onClick={handleOpenReviews} variant="outlined" color="black">
            <img src={imagePath(type)} alt="Show reviews" />
            reviews
          </ReviewsButton>
          <Dialog
            maxWidth="lg"
            fullWidth
            onClose={onClose}
            open={open}
            keepMounted
            disablePortal
            TransitionComponent={Transition}
          >
            <WidgetContainer>
              {!isUrl && (
                <ReviewWidgetFrame html={reviewsWidget} minHeight={400} />
              )}
            </WidgetContainer>
          </Dialog>
        </>
      )}
    </>
  );
}